import { render } from "./ComponentMilestone.vue?vue&type=template&id=27bfa97a&scoped=true"
import script from "./ComponentMilestone.vue?vue&type=script&lang=js"
export * from "./ComponentMilestone.vue?vue&type=script&lang=js"

import "./ComponentMilestone.vue?vue&type=style&index=0&id=27bfa97a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bfa97a"]])

export default __exports__